<template>
  <div class="contact-confirmation-page">
    <fn-section
      constrained="l"
      background-color="sand-light"
      padding-top="xs"
      padding-bottom="xs"
    >
      <fn-breadcrumbs :nodes="page.content.breadcrumbs" />
    </fn-section>

    <fn-section
      constrained="l"
      background-color="sand-light"
      padding-top="s"
      padding-bottom="s"
    >
      <fn-panel-image column-size="6">
        <template
          v-if="image"
          #image
        >
          <img
            :src="image.src"
            :width="image.width"
            :height="image.height"
            :alt="$t('contact.confirmation.title')"
          />
        </template>
        <template #default>
          <fn-section
            no-padding-x
            padding-top="s"
            data-hj-suppress
          >
            <fn-headline
              type="h1"
              size="h2"
            >
              {{ confirmationTitle }}
            </fn-headline>
            <fn-paragraph v-html="$t('contact.confirmation.intro')" />
            <fn-list
              unstyled
              icons
              background-color="orange"
              foreground-color="white"
              colored
            >
              <li>
                <fn-icon
                  icon="email"
                  color="white"
                  size="s"
                />
                {{ contactInformation.email }}
              </li>
              <li>
                <fn-icon
                  icon="alert"
                  color="white"
                  size="s"
                />
                <div v-html="$t('contact.confirmation.hint')" />
              </li>
            </fn-list>

            <div
              v-if="!isAppview"
              class="action-buttons"
            >
              <fn-button
                quaternary
                to="/"
              >
                {{ $t('buttons.continueShopping') }}
              </fn-button>

              <fn-button
                quaternary
                :to="$t('url.account.index')"
              >
                {{ $t('billingAddressWarning.buttons.goToAccount') }}
              </fn-button>
            </div>
          </fn-section>
        </template>
      </fn-panel-image>
    </fn-section>
    <fn-cms-section-loader
      v-if="page.content.content_slots.a && page.content.content_slots.a.sections"
      :sections="page.content.content_slots.a.sections"
    />
  </div>
</template>

<script>
export default defineComponent({
  props: {
    page: {
      type: Object,
      required: true,
    },
    image: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    contactInformation: '',
  }),
  computed: {
    ...mapState(useMainStore, {
      isAppview: 'isAppview',
    }),

    ...mapState(useUserStore, {
      user: 'user',
      isAuthenticated: 'getIsAuthenticated',
    }),

    confirmationTitle() {
      let title = this.$t('contact.confirmation.title');

      if (this.isAuthenticated && this.user && this.user.name) {
        title += `, ${
          this.user.defaultAddress && this.user.defaultAddress.title ? this.user.defaultAddress.title : ''
        } ${this.user.name}`;
      } else if (this.contactInformation.firstName && this.contactInformation.lastName) {
        title += `, ${this.contactInformation.firstName} ${this.contactInformation.lastName}`;
      } else {
        title += this.$t('contact.confirmation.fallback');
      }
      return title;
    },
  },
  created() {
    if (import.meta.client) {
      try {
        this.contactInformation = JSON.parse(localStorage.getItem('contactInformation')) || {};
      } catch (error) {
        this.$log.error('Error occurred while JSON.parse()', error);
        this.contactInformation = {};
      }

      if (!this.contactInformation.email) {
        this.$router.push(this.$t('url.homepage'));
      }
    }
  },
});
</script>

<style lang="scss" scoped>
.action-buttons {
  margin-top: $ui-height;
  margin-bottom: $pad;

  @include bp(m) {
    display: flex;
    justify-content: space-evenly;
  }

  .button {
    width: 100%;
    margin-bottom: $pad;

    @include bp(m) {
      width: auto;
    }
  }
}
</style>
